module.exports = __webpack_public_path__ + "media/description/description@3x-62f64fae.png";